const css = `.z405TG__warningBanner{background-color:var(--special-warning-surfaces-secondary)}.z405TG__patternInput{flex-grow:1}.z405TG__urlRule.z405TG__active{border-left-color:var(--base-strokes-activated);border-left-width:2px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"active":"z405TG__active","patternInput":"z405TG__patternInput","warningBanner":"z405TG__warningBanner","urlRule":"z405TG__urlRule"};
